
    import '/home/ec2-user/Youlify-Design/components/affix/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["affix-demo-basic","affix-demo-on-change","affix-demo-target","affix-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/affix/index.en-US.md?type=demo')
};